import React from 'react';
import GridTable from "../../../../common/components/core/GridTable";
import {useTransfersContext} from "../TransfersContext";
import styles from './UnpaidReceiptsGrid.module.scss';

const UnpaidReceiptsGrid = () => {
  const {
    tableUnpaidReceipts,
    totalCountUnpaidReceipts
  } = useTransfersContext();

  return (totalCountUnpaidReceipts > 0) ? (
    <div className={styles.tableContainer}>
      <GridTable
        table={tableUnpaidReceipts}
        customClassname={{
          container: styles.table,
          row: styles.row,
        }}
      />
    </div>
  ) : null
};

export default UnpaidReceiptsGrid;
